import { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface AuthCardProps {
  children: ReactNode;
  as?: "form" | "div";
  centered?: boolean;
  onSubmit?: (e: React.FormEvent) => void;
  className?: string;
}

export const AuthCard = ({
  children,
  as = "div",
  centered = false,
  onSubmit,
  className,
}: AuthCardProps) => {
  const Component = as;

  return (
    <Component
      onSubmit={onSubmit}
      className={cn(
        "w-full max-w-md space-y-6 p-6 sm:p-8 rounded-2xl bg-background/95 backdrop-blur-md shadow-elegant",
        centered && "text-center",
        className,
      )}
    >
      {children}
    </Component>
  );
};
